import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import type { Direction } from '../data/directionsData';

interface DirectionModalProps {
  direction?: Direction;
  onClose: () => void;
  isToday?: boolean;
}

export const DirectionModal = ({ direction, onClose, isToday = false }: DirectionModalProps) => {
  if (!direction) return null;

  const today = new Date();
  const dayName = new Intl.DateTimeFormat('hi-IN', { weekday: 'long' }).format(today);
  const englishDayName = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(today);

  const getModalTitle = () => {
    if (isToday) {
      return `आज का दिशा शूल [${englishDayName}]`;
    }
    return `${direction.name} दिशा का दिशा शूल`;
  };

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="bg-white rounded-lg w-full max-w-md"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 50, opacity: 0 }}
          onClick={e => e.stopPropagation()}
          role="dialog"
          aria-labelledby="modal-title"
        >
          <div className="bg-red-600 text-white p-4 rounded-t-lg relative">
            <button
              onClick={onClose}
              className="absolute right-4 top-4 text-white hover:text-gray-200"
              aria-label="बंद करें"
            >
              <X size={24} />
            </button>
            <h2 id="modal-title" className="text-2xl font-bold text-center">
              {getModalTitle()}
            </h2>
          </div>

          <div className="p-6 space-y-6">
            <div className="border-b pb-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-red-600">⛔</span>
                <h3 className="text-2xl font-bold">जानकारी</h3>
              </div>
              <p className="text-lg">{direction.description}</p>
            </div>

            <div className="border-b pb-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-green-600">✓</span>
                <h3 className="text-2xl font-bold">उपाय</h3>
              </div>
              <ul className="space-y-2">
                {direction.remedies.map((remedy, index) => (
                  <li key={index} className="text-lg">{remedy}</li>
                ))}
              </ul>
            </div>

            <div>
              <div className="flex items-center gap-2 mb-2">
                <span className="text-purple-600">⚡</span>
                <h3 className="text-2xl font-bold">विशेष</h3>
              </div>
              <p className="text-lg">यदि एक जगह से रवाना हो कर उसी दिन गंतव्य स्थान पर पहुंच जाना तय हो तो ऐसी यात्रा में तिथि- वार नक्षत्र, दिशा-शूल, प्रति शुक, योगिनी आदि का विचार नहीं होता है।</p>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};